import { z } from 'zod'

// updating this model?  don't break current data!
// see _UpdatingSchemas.md
export const ROncologyReviewItem = z.object({
	tumor: z.string(),
	treatmentStatus: z.string(),
	metastaticSite: z.union([z.string(), z.null()]),
	metastaticSiteStatus: z.union([z.string(), z.null()]),
})

export type OncologyReviewItem = z.infer<typeof ROncologyReviewItem>

export const newOncologyReviewItem = (
	tumor: string = '', 
	treatmentStatus: string = '', 
	metastaticSite: string|null = '', 
	metastaticSiteStatus: string|null = ''
): OncologyReviewItem => {
	return {
		tumor,
		treatmentStatus,
		metastaticSite,
		metastaticSiteStatus,
	}
}